<p>
  verifyEmail works!
</p>